import React, { useState, useRef, useEffect } from "react";
import { Form, Row, Col, Image, Button, Table, Modal } from "react-bootstrap";
import { amApi } from "../../../../../api/apiHelper";
import { TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import Loader from "../../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import { serverApi, shortvideosize } from "../../../../../config/Keys";
import { errorAlert, successAlert } from "../../../../../function/alert";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import { Checkbox } from "@material-ui/core";
import isEmpty from "../../../../../store/validation/is-Empty";
import { getExperiencesInRestaurantForShorts } from "../../../../../store/actions/Experience/adminExperienceAction";
import ListExpTableBody from "./ListExpTableBody";
import ListExpTableHead from "./ListExpTableHead";
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import SearchByRestaurant from "../../../superAdminReusable/reusablePopupSuperAdmin/SearchByRestaurant";
import {
  short_videos_add,
  short_videos_edit,
} from "../../../../../store/actions/SuperAdminActions/adminShortVideosAction";
import { base64toBlob } from "../../../../reusableComponents/imageUploadReusableComponent/ReactCropperImageUpload";

const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

const settings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const AddShorts = (props) => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [callToAction, setCallToAction] = useState(1);
  const [Video, setVideo] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [restData, setrestData] = useState({});
  const [expdata, setExpData] = useState({});
  const [selectedExp, setSelecetdExp] = useState({});
  const [copyExpDesc, setcopyExpdesc] = useState(false);
  const videoRef = useRef(null);
  const videoRefdummy = useRef(null);
  const canvasRef = useRef(null);
  const [thumbnails, setThumbnails] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [dummyVideoUrl, setdummyVideoUrl] = useState("");
  const [selecetdThumb, setSelectedThumbnail] = useState(null);
  const [activeThumb, selectActiveThumb] = useState(null);
  const [videoPreviewUrl, setPreviewVideoUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [canceldisable, setcancelDisable] = useState(false);

  const handleClickOpen = () => {
    setShowModal(true);
  };
  const handleClose = () => {
    setState({ ...state, copyrestvideo: !state.copyrestvideo });
    setShowModal(false);
  };

  const token = props.auth.user.accessToken;

  const [state, setState] = useState({
    copyExpDesc: false,
    restaurant_video: [],
    video_url: "",
    compressed_url: "",
    progress: 0,
    thumbnail_url: "",
    actionButton: false,
    copyrestvideo: false,
    copyexpvideo: false,
  });

  const formik = useFormik({
    initialValues: {
      restaurant_id: "",
      restaurant: {},
      experience: {},
      experience_id: "",
      callToAction: callToAction,
      copyExpDesc: false,
      description: "",
      videoUrl: "",
      copyRestVideo: "",
      copyExpVideo: "",
      thumbnailUrl: "",
      expdesc: "",
      restdesc: "",
    },
    validationSchema: yup.object({
      description: yup
        .string()
        .required("Description is required")
        .max(512, "Maximum 512 Characters"),
      // videoUrl: yup.string().required("video  is required"),
    }),

    onSubmit: async (values, { setSubmitting }) => {
      setIsSubmitting(true);
      var formData = {
        restaurant: restData,
        experience: callToAction == 2 ? selectedExp : {},
        videoUrl: state.video_url,
        thumbnailUrl: state.thumbnail_url,
        description: values.description,
        callToAction:
          callToAction == 1 ? "RESTAURANT_PAGE" : "EXPERIENCE_BOOKING_PAGE",
        compressedVideoUrl: state.video_url,
      };

      try {
        if (activeThumb.startsWith("https://amealia.s3.amazonaws.com")) {
          formData.thumbnailUrl = activeThumb;
        } else {
          const thumbnailUrl = await uploadThumbnail(activeThumb);
          formData.thumbnailUrl = thumbnailUrl;
        }
        if (history?.location?.pathname?.includes("edit")) {
          console.log("edit is happeing");
          console.log(formData);
          const updatedFormData = { ...formData, id: props?.editData?._id };
          let x = await props?.short_videos_edit(
            token,
            updatedFormData,
            onSuccessAddShort
          );
        } else {
          await props.short_videos_add(token, formData, onSuccessAddShort);
          setSubmitting(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (history.location.pathname.includes("edit") && state.video_url == "") {
      setcancelDisable(true);
      setIsSubmitting(true);
    } else if (
      history.location.pathname.includes("edit") &&
      state.video_url != ""
    ) {
      setcancelDisable(false);
      setIsSubmitting(false);
    }
  }, [state.video_url]);

  useEffect(() => {
    if (props?.edit && props?.editData) {
      formik.setValues({ ...formik.values, ...props?.editData });
      setCallToAction(
        props?.editData?.callToAction === "RESTAURANT_PAGE" ? 1 : 2
      );
      seturl(props?.editData?.videoUrl);
      setrestData(props?.editData?.restaurant);
      selectActiveThumb(props?.editData?.thumbnailUrl);
      if (props?.editData?.callToAction === "EXPERIENCE_BOOKING_PAGE") {
        getExperiencesInRestaurantForShorts(
          props?.editData?.restaurant?._id,
          token,
          onsucces
        );
        setSelecetdExp(props?.editData?.experience);
      }
    }
  }, [props?.edit]);

  const onClickDisplaySearch = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
    setShowFilter(false);
  };

  const onClickDisplayFilter = (e) => {
    e.preventDefault();
    setShowFilter(!showFilter);
    setShowSearch(false);
  };

  const onSuccessAddShort = () => {
    history.push("/superadmin/short-videos");
  };

  const RenderExpTable = (filteredData) => {
    if (!isEmpty(filteredData)) {
      return filteredData.map((data, index) => (
        <React.Fragment key={index}>
          <ListExpTableBody
            expdata={data}
            selectexp={(e) => {
              setSelecetdExp(e);
            }}
            selectedExp={selectedExp}
          />
        </React.Fragment>
      ));
    } else {
      return (
        <React.Fragment>
          <div className="text-center">
            <h3 className="f16-500 opacity5 py-2">
              No Active Experiences Found
            </h3>
          </div>
        </React.Fragment>
      );
    }
  };

  useEffect(() => {
    if (!isEmpty(restData)) {
      getExperiencesInRestaurantForShorts(restData?._id, token, onsucces);
    }
  }, [restData, callToAction]);

  const onsucces = (data) => {
    setExpData(data);
  };

  const onChangeRestaurant = (data) => {
    if (data) {
      data["name"] = data?.restaurant_name;
      data["address"] = data?.restaurant_address;
      setrestData(data);
      formik.setFieldValue("restaurant", data);
      getExperiencesInRestaurantForShorts(data?._id, token, onsucces);
    }
  };

  const seturl = (url) => {
    setState({ ...state, video_url: url });
    setVideoUrl(url);
  };

  let filtereddata = expdata;
  if (searchData) {
    let searchDatatxt = new RegExp(searchData, "i");
    filtereddata = expdata.filter((getall) => {
      if (searchDatatxt.test(getall?.name)) {
        return getall;
      } else {
        return false;
      }
    });
  }

  // const uploadMultipleVideoFiles = async (e) => {
  //   e.preventDefault();
  //   let flag = false;
  //   let error_message = "";
  //   const data = new FormData();
  //   const file = e.target.files[0];
  //   const video_url = URL.createObjectURL(file);

  //   const video = document.createElement("video");
  //   video.src = video_url;

  //   video.addEventListener("loadedmetadata", function () {
  //     if (video.duration > 60) {
  //       console.log("erorrr");
  //       flag = true;
  //       error_message = "video is too long";
  //       errorAlert(error_message);
  //     } else {
  //       flag = false;
  //       error_message = "";
  //     }
  //   });

  //   for (let i = 0; i < e.target.files.length; i++) {
  //     console.log(videoRef.current);
  //     if (e.target.files[i].size > shortvideosize) {
  //       //alert("File is too Big");
  //       error_message = "Size should be less than 650 MB";
  //       flag = true;
  //       setVideoUrl("");
  //     }
  //      else {
  //       if (state.restaurant_video && state.restaurant_video.length > 0) {
  //         flag = true;
  //       }
  //       if (!flag) {
  //         data.append("file", e.target.files[i]);
  //       }
  //     }
  //   }
  //   var newData = e.target.files;
  //   if (!flag) {
  //     const setProgress = (percent) => {
  //       setState({ ...state, progress: percent });
  //     };
  //     axios
  //       .post(`${serverApi}/upload/reels`, data, {
  //         onUploadProgress: (progressEvent) => {
  //           setProgress((progressEvent.loaded / progressEvent.total) * 100);
  //         },
  //         timeout: 60 * 1000, //seconds
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       })
  //       .then((uploadVideo) => {
  //         setState({
  //           ...state,
  //           restaurant_video: newData,
  //           video_url: uploadVideo.data,
  //           actionButton: true,
  //           compressed_url: uploadVideo.data,
  //         });
  //         // formik.setFieldValue("videos", [uploadVideo.data]);
  //         setVideoUrl(video_url);
  //         Alert.success(`<h4> Video Uploaded Successfully</h4>`, {
  //           position: "top-right",
  //           effect: "bouncyflip",
  //           beep: true,
  //           html: true,
  //           timeout: 3000,
  //           offset: 35,
  //         });
  //       })
  //       .catch((err) => {
  //         Alert.error(`<h4>${err}</h4>`, {
  //           position: "top-right",
  //           effect: "bouncyflip",
  //           beep: true,
  //           html: true,
  //           timeout: 3000,
  //           offset: 35,
  //         });
  //       });
  //   } else {
  //     errorAlert(error_message);
  //   }
  // };

  const checkVideoDuration = (video) => {
    return new Promise((resolve, reject) => {
      video.addEventListener("loadedmetadata", () => {
        if (video.duration > 60) {
          console.log("errorrr");
          reject("Time limit should not exceed 60 seconds");
        } else {
          resolve();
        }
      });
    });
  };

  const uploadMultipleVideoFiles = async (e) => {
    e.preventDefault();
    e.persist();

    const file = e.target.files[0];
    const video_url = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.src = video_url;

    try {
      await checkVideoDuration(video);
      console.log(file, "fileeeeeee");
      let flag = false;
      let error_message = "";
      const data = new FormData();
      console.log(e.target.files, "e.target");
      // for (let i = 0; i < e.target.files.length; i++) {
      if (file.size > shortvideosize) {
        error_message = "Size should be less than 650 MB";
        flag = true;
        setVideoUrl("");
        // break; // Exit the loop if any file exceeds the size limit
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          flag = true;
          // Exit the loop if the restaurant_video is already populated
        }
        //  console.log(e.target.files[i],"filesssssss");
        data.append("file", file);
      }
      // }

      if (!flag) {
        console.log(data, "videodataaaa");
        const setProgress = (percent) => {
          setState({ ...state, progress: percent });
        };

        const uploadVideo = await axios.post(
          `${serverApi}/upload/reels`,
          data,
          {
            onUploadProgress: (progressEvent) => {
              setProgress((progressEvent.loaded / progressEvent.total) * 100);
            },
            timeout: 60 * 1000, // seconds
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const newData = e.target.files;
        setState({
          ...state,
          restaurant_video: newData,
          video_url: uploadVideo.data,
          actionButton: true,
          compressed_url: uploadVideo.data,
        });
        setVideoUrl(video_url);
        Alert.success(`<h4>Video Uploaded Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        errorAlert(error_message);
      }
    } catch (error) {
      errorAlert(error);
    }
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state?.video_url;
    let restaurant_video = state?.restaurant_video;
    axios.delete(`${serverApi}/upload/reels?url=${video_url}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
    setThumbnails([]);
    formik.setFieldValue("videos", video_url);
    formik.setFieldError("videoUrl", "Video URL is required.");
  };

  const CopyDesc = () => {
    if (!copyExpDesc) {
      formik.setFieldValue("copyExpDesc", state.copyExpDesc);
      if (selectedExp) {
        formik.values.description = selectedExp.description || " ";
      }
    } else {
      formik.values.description = " ";
    }
    setcopyExpdesc(!copyExpDesc);
  };

  console.log(formik.values.videoUrl, "videourllllllllll");

  const copyRestaurantVideo = () => {
    if (state.copyrestvideo) {
      setState({ ...state, copyrestvideo: !state.copyrestvideo });
    } else {
      setState({ ...state, copyrestvideo: !state.copyrestvideo });
      setShowModal(!showModal);
    }
    // formik.setFieldValue("copyRestVideo", restData?.restaurant_video);
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    const videoUrl = URL.createObjectURL(file);
    setVideoUrl(videoUrl);
  };

  const uploadThumbnail = async (base_64) => {
    console.log(base_64, "dataaaaaaaa");
    let file = await base64toBlob(base_64);
    const timestamp = moment().unix();
    var newfile = new File([file], `${timestamp}.png`, {
      type: "image/png",
    });

    var data = new FormData();
    data.append("files", newfile);
    let thumbnails = await axios.post(
      `${serverApi}/upload-assets?uploadSide=${timestamp}`,
      data
    );
    setState({ ...state, thumbnail_url: thumbnails?.data?.[0] });
    return thumbnails?.data?.[0];
  };

  useEffect(() => {
    const isS3BucketUrl = videoUrl?.includes("amazonaws.com");
    const generateThumbnails = async () => {
      if (videoRef.current && canvasRef.current) {
        console.log("videothumbnail genrating");

        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (!isS3BucketUrl) {
          console.log(!isS3BucketUrl, "starts with s3", videoUrl);
          if (video.duration <= 60) {
            const interval = video.duration / 5; // Capture 5 thumbnails
            const capturedThumbnails = [];

            for (
              let currentTime = 0;
              currentTime < video.duration;
              currentTime += interval
            ) {
              video.currentTime = currentTime;
              await new Promise((resolve) => {
                video.onseeked = () => {
                  const aspectRatio = video.videoWidth / video.videoHeight;
                  const thumbnailWidth = 200; // Adjust the desired width as needed
                  const thumbnailHeight = thumbnailWidth / aspectRatio;

                  canvas.width = thumbnailWidth;
                  canvas.height = thumbnailHeight;
                  canvas
                    .getContext("2d")
                    .drawImage(video, 0, 0, canvas.width, canvas.height);
                  const thumbnailUrl = canvas.toDataURL("image/png");
                  capturedThumbnails.push(thumbnailUrl);
                  resolve();
                };
              });
            }

            setThumbnails(capturedThumbnails);
          } else {
            Alert.error(
              `<h4>${"Time limit should not exceed 60 seconds"}</h4>`,
              {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 5000,
                offset: 35,
              }
            );
            multipleVideoResetFile();
            console.log(
              "Video duration exceeds the limit. Thumbnails will not be generated."
            );
            setThumbnails([]); // Reset the thumbnails if the video duration exceeds the limit
          }
        } else {
          // S3 bucket URL scenario
          const thumbnailUrl = props?.editData?.thumbnailUrl; // Default empty thumbnail URL
          setThumbnails([thumbnailUrl]);
        }
      }
    };

    const video = videoRef.current;

    if (videoUrl && video) {
      console.log("Adding event listener...");
      video.addEventListener("loadedmetadata", generateThumbnails);
      if (isS3BucketUrl) {
        // fetch(videoUrl) // Fetch video data from the S3 URL
        //   .then((response) => response.blob()) // Get the video as a Blob
        //   .then((videoBlob) => {
        //     const objectUrl = URL.createObjectURL(videoBlob); // Create an object URL for the video
        //     video.src = objectUrl; // Set the object URL as the source of the video element
        //   })
        //   .catch((error) => {
        //     console.log("Error fetching the video:", error);
        //   });
      } else {
        // Handle regular video upload scenario
        video.src = videoUrl; // Set the videoUrl as the source of the video element
      }
    }
  }, [videoUrl]);

  const formpost = () => {
    formik.handleSubmit();
  };

  useEffect(() => {
    if (restData?.restaurant_video) {
      setPreviewVideoUrl(restData?.restaurant_video);
    }
  }, [restData]);

  console.log(expdata, "esxpdataaaaaaaaaaa");

  return (
    <>
      <React.Fragment>
        {!loading ? (
          <>
            <Form>
              <Row className="pt-4">
                <Col lg={6}>
                  <SearchByRestaurant
                    setrestdata={(data) => {
                      onChangeRestaurant(data);
                    }}
                    edit={props?.edit}
                    restaurant={{
                      ...props?.editData?.restaurant,
                      restaurant_name: props?.editData?.restaurant?.name,
                      restaurant_address: props?.editData?.restaurant?.address,
                    }}
                  />
                </Col>
                <Col lg={12} className="mt-3">
                  <Form.Group>
                    <Form.Label className="f14-500">Call to Action</Form.Label>
                    <div
                      className="row col-12 d-flex column-2 align-items-center"
                      style={{
                        paddingTop: "2vh",
                        borderRadius: "12px",
                      }}
                    >
                      <div
                        className="position-relative pl-0 col-md-2 col-6 mr-0"
                        onClick={() => setCallToAction(1)}
                      >
                        <div
                          className={`w-100 mb-3 mr-3   onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type ${
                            callToAction === 1 &&
                            `onboarding_mapbutton_reusable_active_two`
                          }`}
                          style={{ borderRadius: "12px" }}
                        >
                          <div className="d-flex align-items-center">
                            <span style={{ fontSize: "2vh" }}>
                              {" "}
                              Restaurant Page
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        className="position-relative col-md-2 col-6 mr-0"
                        onClick={() => setCallToAction(2)}
                      >
                        <div
                          className={`w-100 mb-3 mr-3  onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type ${
                            callToAction === 2 &&
                            `onboarding_mapbutton_reusable_active_two`
                          }`}
                          style={{ borderRadius: "12px" }}
                        >
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "2vh", whiteSpace: "nowrap" }}
                            >
                              {" "}
                              Experience Booking Page
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {callToAction == 2 && expdata.length > 0 ? (
                      <>
                        <Col lg={10} className="mt-4">
                          <h5 className="f16-500">
                            List of active Experiences
                          </h5>
                          <hr className="mb-2" />
                          <Row>
                            <Col md={6} className="d-flex align-items-center">
                              <div className="d-flex align-items-center">
                                <Image
                                  alt="Search"
                                  title="Search"
                                  width="60px"
                                  src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
                                  onClick={(e) => onClickDisplaySearch(e)}
                                />
                              </div>
                            </Col>
                            <Col
                              md={6}
                              className="col-md-6 d-flex align-items-center justify-content-end"
                            >
                              <h5 className="f12-400">
                                Total Number of Experiences : `
                                {expdata ? expdata.length : 0}`
                                {props.auth.secondary_loader ? (
                                  <div className="ml-2">
                                    <Loader
                                      type="ThreeDots"
                                      color="#00BFFF"
                                      height={25}
                                      width={25}
                                    />
                                  </div>
                                ) : null}
                              </h5>
                            </Col>
                            <div className="col-12">
                              {showSearch && (
                                <div className="my-3">
                                  <ZoomDiv>
                                    <div className="w-25">
                                      <Form.Control
                                        type="text"
                                        placeholder="Search"
                                        value={searchData}
                                        onChange={(e) =>
                                          setSearchData(e.target.value)
                                        }
                                        className="amSearch"
                                      />
                                    </div>
                                  </ZoomDiv>
                                </div>
                              )}
                              {/* {showFilter && (
                                <div
                                  className="container-fluid p-4"
                                  style={{ backgroundColor: "#ffffff" }}
                                >
                                  <Row>
                                    <Col md={6}>
                                      <Form.Group>
                                        <FormControl
                                          variant="outlined"
                                          className="w-100"
                                        >
                                          <InputLabel htmlFor="outlined-Status">
                                            City
                                          </InputLabel>
                                          <Select
                                            // onChange={(e) =>
                                            //   setState({
                                            //     ...state,
                                            //     restaurantCity: e.target.value,
                                            //   })
                                            // }
                                            label="City"
                                            inputProps={{
                                              name: "restaurantCity",
                                              id: "outlined-Status",
                                            }}
                                            IconComponent={
                                              KeyboardArrowDownIcon
                                            }
                                          >
                                            <option value={""} disabled>
                                              Select option
                                            </option>
                                          </Select>
                                        </FormControl>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                  <div className="mt-5 d-flex">
                                    <button
                                      type="button"
                                      onClick={() => setShowFilter(false)}
                                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                                      title="Reset Filter"
                                    >
                                      Reset
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => setShowFilter(false)}
                                      className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                      title="Search Filter"
                                    >
                                      Search
                                    </button>
                                  </div>
                                </div>
                              )} */}
                            </div>
                            <Col sm={12}>
                              {props.auth.secondary_loader ? (
                                <Loader
                                  type="ThreeDots"
                                  color="#00BFFF"
                                  height={25}
                                  width={25}
                                />
                              ) : (
                                <div
                                  className="col-12 p-0 user-table-reusable-superadmin my-2"
                                  style={{
                                    // maxHeight: "400px",
                                    // overflow: "auto",
                                    border: "1px solid #00000029",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <Table
                                    style={{
                                      borderSpacing: 0,
                                      borderCollapse: "collapse",
                                    }}
                                  >
                                    <thead>
                                      <ListExpTableHead
                                      // restaurantsOnChange={() =>
                                      //   onHeadCheckBox(
                                      //     vendorUserData && vendorUserData,
                                      //     formik1.values.restaurants
                                      //   )
                                      // }
                                      // selectedCheck={formik1.values.headCheck}
                                      />
                                    </thead>
                                    <div
                                      id="style-4"
                                      style={{
                                        maxHeight: "400px",
                                        overflow: "auto",
                                      }}
                                    >
                                      {RenderExpTable(filtereddata)}
                                    </div>
                                  </Table>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </>
                    ) : callToAction == 2 && expdata.length == 0 ? (
                      <React.Fragment>
                        <div className="text-center">
                          <h3 className="f16-500 opacity5 py-2">
                            No Active Experiences Found
                          </h3>
                        </div>
                      </React.Fragment>
                    ) : null}
                    <div className=" row">
                      <div className="col-6">
                        <Form.Group>
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <div>
                              <Form.Label className="f14-500 ">
                                Description
                              </Form.Label>
                            </div>
                            {callToAction == 2 && !isEmpty(selectedExp) && (
                              <>
                                <div className="d-flex align-items-center">
                                  <Checkbox
                                    onChange={CopyDesc}
                                    checked={copyExpDesc}
                                    style={{ color: "#EE3A23" }}
                                  />
                                  <div className={`f14-400 pr-2`}>
                                    Copy experience description
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          <TextField
                            id="description"
                            label="Description"
                            type="text"
                            variant="outlined"
                            className={`w-100  ${
                              formik.errors.description &&
                              formik.touched.description
                                ? "enError"
                                : ""
                            }`}
                            helperText={
                              formik.errors.description &&
                              formik.touched.description
                                ? formik.errors.description
                                : "Max 512 characters"
                            }
                            name="description"
                            multiline={true}
                            minRows="5"
                            onBlur={formik.handleBlur}
                            value={formik.values.description}
                            error={
                              formik.errors.description &&
                              formik.touched.description
                            }
                            onChange={formik.handleChange}
                            isInvalid={
                              formik.errors.description &&
                              formik.touched.description
                            }
                            disabled={formik.values.copyExpDesc}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </Form.Group>

                  <Form.Group>
                    <div className="event-offer-image">
                      <div className="d-flex justify-content-between align-items-center my-2 col-6 pl-0">
                        <div>
                          <Form.Label className="f14-500">
                            {/* change */}
                            Upload short videoSSS
                          </Form.Label>
                        </div>
                        {/* {restData?.restaurant_video && (
                          <>
                            <div className="d-flex align-items-center">
                              <Checkbox
                                onChange={copyRestaurantVideo}
                                checked={state.copyrestvideo}
                                style={{ color: "#EE3A23" }}
                              />
                              <div className={`f14-400 pr-2`}>
                                Copy restaurant video
                              </div>
                            </div>
                          </>
                        )} */}

                        {/* {callToAction == 2 && !isEmpty(selectedExp) ? (
                          <>
                            <div className="d-flex align-items-center">
                              <Checkbox
                                // onChange={copyTimings}
                                // checked={formik.values.copyTimings}
                                style={{ color: "#EE3A23" }}
                              />
                              <div className={`f14-400 pr-2`}>
                                Copy experience video
                              </div>
                            </div>
                          </>
                        ) : null} */}
                      </div>
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title=""
                          onChange={uploadMultipleVideoFiles}
                          stateValue={
                            state.video_url === "" ? [] : [state.video_url]
                          }
                          removeImage={multipleVideoResetFile}
                          accept="video/*"
                          singleUpload={true}
                          videoUpload={true}
                          // smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                        />
                        <div className="font_12_r  mb-4 d-flex">
                          (Size should be less than 650 MB <br />
                          Time limit should not exceed 60 seconds )
                        </div>
                      </SimpleReactLightbox>
                      {!state.progress && state.progress === 0 ? null : (
                        <AlertDialogProgress
                          progress={state.progress}
                          title="Video Uploading..."
                        />
                      )}
                    </div>
                  </Form.Group>
                  <div>
                    <div style={{ display: "none" }}>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={handleVideoUpload}
                      />
                      <div className="my-3">
                        {videoUrl && (
                          <video ref={videoRef} src={videoUrl} controls />
                        )}
                      </div>
                      {/* <div className="my-3">
                        {dummyVideoUrl && (
                          <video
                            ref={videoRefdummy}
                            src={dummyVideoUrl}
                            controls    
                          />
                        )}
                      </div> */}
                    </div>
                    <div>
                      {thumbnails.length ? (
                        <div className="f12-500 my-2">
                          {" "}
                          {thumbnails.length == 1
                            ? "selected thumbnail"
                            : "Select any one thumbnail"}
                        </div>
                      ) : null}
                      <div
                        className="my-2 hidescrollbar"
                        style={{
                          // width: "300px",
                          overflowX: "scroll",
                          display: "flex",
                        }}
                      >
                        {thumbnails.map((thumbnailUrl, index) => (
                          <img
                            key={index}
                            src={thumbnailUrl}
                            alt={`Thumbnail ${index}`}
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: "cover",
                              maxWidth: "200px",
                            }}
                            className={`mx-2  ${
                              selecetdThumb === index ? `borderActive` : ""
                            } `}
                            onClick={() => {
                              selectActiveThumb(thumbnailUrl);
                              setSelectedThumbnail(index);
                            }}
                          />
                        ))}
                      </div>
                    </div>
                    <canvas ref={canvasRef} style={{ display: "none" }} />
                  </div>
                  <div></div>

                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={() => {
                        history.push("/superadmin/short-videos");
                      }}
                      disabled={canceldisable}
                    >
                      Cancel
                    </Button>
                    {callToAction == 2 && isEmpty(selectedExp) ? null : (
                      <>
                        <Button
                          variant="danger"
                          className="btn-lg px-5 btn150px"
                          // type="submit"
                          disabled={isSubmitting}
                          onClick={() => formpost()}
                        >
                          Save
                        </Button>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              <VideoPreviews
                videoUrl={videoPreviewUrl}
                show={showModal}
                handleClose={handleClose}
                handleOpen={handleClickOpen}
                formik={formik}
                setShowModal={setShowModal}
                setVideo={seturl}
              />
            </Form>{" "}
          </>
        ) : (
          <AmealioLoader />
        )}
      </React.Fragment>
    </>
  );
};

AddShorts.propTypes = {
  auth: PropTypes.object.isRequired,
  short_videos_add: PropTypes.func.isRequired,
  short_videos_edit: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  short_videos_add,
  short_videos_edit,
})(AddShorts);

const VideoPreviews = (props) => {
  const [open, setOpen] = useState(false);
  const OnClsoe = () => {
    setOpen(false);
  };
  const [activeBorder, setActiveBorder] = useState(false);

  const handleSelect = () => {
    if (activeBorder) {
      props.setVideo(props?.videoUrl);
      // setState({...state,video_url:props.videoUrl})
    }
    props.setShowModal(false);
  };
  return (
    <>
      <Modal show={props?.show} onHide={props.handleClose} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title> Select Restaurant Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          {props.videoUrl && (
            <div>
              <video
                src={props.videoUrl}
                controls
                width="200px"
                height="100px"
                className={activeBorder ? "borderActive" : ""}
                onClick={() => {
                  setActiveBorder(!activeBorder);
                }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={props.handleClose}
          >
            cancel
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleSelect}
          >
            select
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
